import ContentLayout from '@/layouts/content-layout'
import OrderPrivilegeView from '@/sections/order-privilege/view/order-privilege-view'

export default function OrderPrivilegePage() {
  return (
    <ContentLayout title="จัดส่งรางวัล">
      <OrderPrivilegeView />
    </ContentLayout>
  )
}
